var React = require('react');

function Co (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#ffe800","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#00148e","d":"M0 240h640v240H0z","key":1}),React.createElement("path",{"fill":"#da0010","d":"M0 360h640v120H0z","key":2})]));
}

Co.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Co;

Co.default = Co;
